import { SQ_EN } from './questions-en';
import { SQ_FR } from './questions-fr';

export const questionSrcDb = () => {
    const m = new Map();
    [
        SQ_EN(),
        SQ_FR(),
    ]
    .forEach(questionSet => {
        (<any[]>questionSet).forEach(question => {
            if (m.has((<any>question).taskId)){
                console.error('Question Task ID collision (likely between multi-lingual')
            }
            m.set((<any>question).taskId, question);
        });
    })
    return m
}